export class DevReload extends HTMLElement {
  private sse: EventSource | null = null;
  private pollInterval: number | null = null;
  private isServerConnected: boolean = false;

  constructor() {
    super();
  }

  connectedCallback(): void {
    this.style.display = "none";
    this.connect();
  }

  disconnectedCallback(): void {
    this.cleanup();
  }

  private connect(): void {
    this.sse = new EventSource("/_dev/reload");
    this.sse.onopen = (): void => {
      this.isServerConnected = true;
      console.log("[DEV-RELOAD] Dev server connected.");
    };
    this.sse.onerror = (): void => {
      this.sse?.close();
      if (!this.isServerConnected) {
        console.error("[DEV-RELOAD] Could not connect to dev server.");
        return;
      }
      console.log("[DEV-RELOAD] Server disconnected. Waiting to reconnect...");
      this.startPolling();
    };
  }

  private startPolling(): void {
    if (this.pollInterval !== null) return;

    this.pollInterval = window.setInterval(() => {
      fetch(window.location.href, { method: "HEAD" })
        .then((response: Response) => {
          if (response.ok) {
            this.cleanup();
            window.location.reload();
          }
        })
        .catch(() => {});
    }, 100);
  }

  private cleanup(): void {
    if (this.sse) {
      this.sse.close();
      this.sse = null;
    }
    if (this.pollInterval !== null) {
      window.clearInterval(this.pollInterval);
      this.pollInterval = null;
    }
  }
}
